// getters.js

const getters = {
    totalCount: (state) => state.data.length,
  
    filteredData: (state) => (filter) => {
      return state.data.filter(item => item.category === filter);
    },
  };
  
  export default getters;
  